import Experiment from '@mc/experiments-react'
import { HeroSection } from 'pages/certificates/components/MarketingHubPage'
import { MCCERTS_2805_HUB_VALUE_PROP_FLAG } from '../constants'
import { HeroSectionVariant } from './HeroSectionVariant'

export const HeroSectionValuePropsExp = () => (
  <Experiment
    name={MCCERTS_2805_HUB_VALUE_PROP_FLAG}
    control={() => <HeroSection />}
    default={() => <HeroSectionVariant />}
  />
)
